import { classNames } from '@dimjs/utils';
import { hooks } from '@wove/react';
import { useRef, useState } from 'react';
import { useEffectCustom } from '../hooks';
import { useDocumentEvent } from '../hooks/use-document-event';
import { Modal, ModalProps } from '../modal';
import { getZIndex } from '../utils';
import './style.less';
export type ModalPoptipProps = {
  content: string | JSX.Element;
} & Omit<ModalProps, 'getContainer'>;

export const ModalPoptip = (props: ModalPoptipProps) => {
  const { content, visible, className, ...otherProps } = props;
  const [zIndex, setZIndex] = useState(0);
  const [bodyZIndex, setBodyZIndex] = useState(0);
  const afterOpenRef = useRef(false);
  const poptipWrapRef = useRef<HTMLDivElement>(null);
  const poptipContentRef = useRef<HTMLDivElement>(null);
  const poptipTiggerWidth = useRef<number>(0);

  useEffectCustom(() => {
    if (visible) {
      poptipTiggerWidth.current = (poptipWrapRef.current?.children[0] as HTMLElement)?.offsetWidth;
    }
  }, [visible]);

  useDocumentEvent(
    () => {
      if (!afterOpenRef.current) return;
      afterOpenRef.current = false;
      props.onClose?.();
    },
    ['click'],
    [poptipContentRef.current],
  );

  const onBeforeOpen = hooks.useCallbackRef(() => {
    setZIndex(getZIndex());
    setBodyZIndex(getZIndex());
    props.onBeforeOpen?.();
  });

  const onAfterOpen = hooks.useCallbackRef(() => {
    afterOpenRef.current = true;
  });

  return (
    <div className="v-poptip">
      <div className="v-poptip-wrap" style={{ zIndex }} ref={poptipWrapRef}>
        {props.children}
      </div>
      <Modal
        closeIcon={false}
        closeByMask={true}
        mask={false}
        clickStopPropagation={false}
        {...otherProps}
        visible={visible}
        className={classNames('v-modal-poptip', className)}
        getContainer={null}
        onBeforeOpen={onBeforeOpen}
        onAfterOpen={onAfterOpen}
        bodyStyle={{ zIndex: bodyZIndex, ...props.bodyStyle }}
        forceRender={true}
      >
        <div className="v-modal-poptip-arrow-wrapper" style={{ width: poptipTiggerWidth.current || '100%' }}>
          <div className="v-modal-poptip-arrow"></div>
        </div>
        <div className="v-modal-poptip-content" ref={poptipContentRef}>
          {content}
        </div>
      </Modal>
    </div>
  );
};
